/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Export Markers" |
*
* @param {Markers_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_title = /** @type {((inputs?: Markers_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter les marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportmarkierungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспортные маркеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcadores de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートマーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात मार्कर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcadores de exportação")
	return /** @type {LocalizedString} */ ("Export Markers")
});